import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

interface Params {
  skill_id?: string;
}

export default class AuthenticatedCareerPathwaysSkillsAssessmentRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model({ skill_id }: Params) {
    const skillId = skill_id || 'leadership'; // Default to leadership assessment
    const questions = await this.reimaginedData.fetchAssessmentQuestions(skillId);

    return {
      skillId,
      questions,
    };
  }
}
